import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PropTypes from 'prop-types';
import ReportList from '../report_list';

import { withStyles } from '@material-ui/core/styles';

import { navigate } from '../../actions';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    }
});

class InfVentas extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                {this.props.user?<ReportList group={0} />  :null}              
            </div>
        );

    };

};

InfVentas.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(InfVentas));